import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import MixinStock from '@mixins/stock'
import MixinFats from '@mixins/fats'
import MixinPlayer from '@/mixins/player'
import MixinGame from '@mixins/game'
import ModalPlugin from '@plugins/modal/index'

@Component
export default class WinGame extends mixins(MixinStock, MixinFats, MixinPlayer, MixinGame) {
  public countdownTimer: number = 60

  get teamAHasWon(): boolean {
    return this.gameIsWonByTeam !== null && this.gameIsWonByTeam.toLowerCase() === 'a'
  }

  public exitGame() {
    location.reload()
  }

  public startFinalCountdown() {
    const finalCountdown = setInterval(() => {
      if (this.countdownTimer === 0) {
        this.countdownTimer = 10
        clearInterval(finalCountdown)
        this.exitGame()
      }

      this.countdownTimer--
    }, 1000)
  }

  public mounted() {
    ModalPlugin.event.$on('open', (name: string, params: object) => {
      if (name === 'win-game') {
        this.startFinalCountdown()
      }
    })
  }
}
